import { render } from "./ChangeLogView.vue?vue&type=template&id=ced48584&ts=true"
import script from "./ChangeLogView.vue?vue&type=script&lang=ts"
export * from "./ChangeLogView.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__